import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=340b51d0&"
import script from "./fees.vue?vue&type=script&lang=js&"
export * from "./fees.vue?vue&type=script&lang=js&"
import style0 from "./fees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports